import { useSelector } from "react-redux";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";

import { getDefaultSourceObjectKey } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

const useDefaultSourceObjectKey = (
  entityType: EntityType | undefined
): HasSourceObject["sourceObject"] =>
  useSelector((state: RootState) => getDefaultSourceObjectKey(state, entityType));

export default useDefaultSourceObjectKey;
